import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}carriers/PackingParcel/${COMMON_QUERY_PARAMS.ID}/url`;

interface GetCarrierLabelUrlByPackingParcelIdQueryArgs {
  packingParcelId: string;
}

async function getCarrierLabelUrlByPackingParcelIdQuery({
  packingParcelId,
}: GetCarrierLabelUrlByPackingParcelIdQueryArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.ID, packingParcelId);

    const response = await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getCarrierLabelUrlByPackingParcelIdQuery;
